module.exports = __webpack_public_path__ + "img/winner.90d5c3f5.png";